import React from 'react';
import './FAQs.css';

// Import required components and constants
import { Faqs, Heading } from '../../../components';
import { faqsContent, images } from '../../../constants';



const FAQs = () => {
  return (
    <section className='faq-section'>

      <div className='box-container'>

        {/* Faq Image */}
        <div className='image'>
          <img src={images.FAQs} alt='FAQs-Pic' />
        </div>

        <div className='faq-container'>

          {/* Section heading */}
          <Heading title={'Frequently Asked Questions'} subTitle={"FAQ's"} sideHeading />

          {/* Faq Accordion container */}
          <Faqs faqs={faqsContent} />

        </div>

      </div>

    </section>
  )
}

export default FAQs;